<script>
  import ShoppingCart from '../components/ShoppingCart.svelte'
  import { userStore, logout, changeClient } from '../services/session';
  import { _, langs, locale } from '../services/i18n'
  import { getOrderData } from '../services/orders';
  import { getDBLines, cartStore } from '../services/shoppingCart';

  import { fly, slide } from 'svelte/transition'

  import Loading from "./Loading.svelte"
    import { onMount } from 'svelte';

  const closeAll = () => status.toggle('')

  let status = {
    /**
     * @param {('user'|'cart'|'')} option
     */
    toggle: option => {
      Object.keys(status).forEach(key =>
        status[key] = status[key] === true && key !== option 
                        ? false 
                        : status[key])
      if(option !== '')
        status[option] = !status[option]
      status = status
    },
    user: false,
    cart: false
  }

  const logoutButton = () => {
    status.user = false
    status.cart = false
    logout()
  }

  let langOption = false

  let index, tutoOpen = false, tutoPath = '';

  let numShoppingCartItems = 0;
  onMount(async () => {
    numShoppingCartItems = 0;
    const dbLines = await getDBLines();
    if (Array.isArray(dbLines)) {
      numShoppingCartItems += dbLines.length;
    }
    if ($cartStore) {
      const orderLines = await getOrderData({ orderId: $cartStore });
      if (Array.isArray(orderLines.data)) {
        numShoppingCartItems += orderLines.data.length;
      }
    }

  })
</script>
<svelte:body on:keydown={() => {}} on:click={closeAll}/>

<nav on:keydown={() => {}} on:click|stopPropagation>
  <div class="icons-nav">
    {#if $userStore.login}
    <header>
      <span class="arrow-item" class:active-item={status.user}>
        <img src="/icons/list.svg" on:keydown={() => {}} on:click|stopPropagation={status.toggle('user')} id="list-icon" alt="icon"/>
      </span>
      <span class:active-item={tutoOpen}>
        <img src="/icons/info.svg" on:keydown={() => {}} on:click={() => { tutoOpen = true }} alt="icon"/>
      </span>
    </header>
    <body>
      <span class="arrow-item shopping-cart-button" class:active-item={status.cart}>
        {#if numShoppingCartItems > 0 }
          <div class="s3d-badge">{numShoppingCartItems}</div>
        {/if}
        <img src="/icons/carrito.svg" on:keydown={() => {}} on:click={status.toggle('cart')} alt="icon"/>
      </span>
    </body>
    <footer>
      <span>
        <img src="/icons/logout.svg" class="filter-white" on:keydown={() => {}} on:click={logoutButton} alt="icon"/>
      </span>
    </footer>
    {/if}
  </div>
</nav>

{#if Object.values(status).some(a => a === true)}
<div class="user user-visible" in:fly={{ x: 500, duration: 300 }} out:fly={{ x: 500, duration: 200 }} on:keydown={() => {}} on:click|stopPropagation>
  <a id="logo-sim3d-mobile" href="/"><img alt="sim3d-logo" src="/icons/sim3d-logo.svg" /></a>
  <span class="arrow-item" class:active-item={status.user}>
    <img src="/icons/close.svg" on:keydown={() => {}} on:click={status.toggle('user')} id="close-list-icon" alt="icon"/>
  </span>
  <div class="arrow" on:keydown={() => {}} on:click={closeAll}>
    <img src="/icons/arrow.svg" alt="arrow"/>
  </div>
  {#if status.user}
  <ul class="user-actions" in:fly={{ x: 500, duration: 300 }} out:fly={{ x: 500, duration: 100 }}>
    <li class="title"><img src="/icons/user.svg" alt="user" id="user-icon"/>{$_('nav_user_user')}</li>
     {#if $userStore.getAcl('orderList')}
     <li><a href="#/orders" on:keydown={() => {}} on:click={status.toggle('user')}><span>{$_('nav_user_orders')}</span></a></li>
     {/if}
     <!-- <li><span>{$_('nav_user_returns')}</span></li> -->
     {#if $userStore.getAcl('budgetList')}
     <li><a href="#/budgets" on:keydown={() => {}} on:click={status.toggle('user')}><span>{$_('nav_user_budgets')}</span></a></li>
     {/if}
     {#if $userStore?.clients.length > 1 && $userStore.getAcl('multiclient')}
     <li><span on:keydown={() => {}} on:click={changeClient.change}>{$_('nav_user_clientSelector')}</span></li>
     {/if}
     {#if $userStore.getAcl('manageUsers')}
     <li><a on:keydown={() => {}} on:click={status.toggle('')} href="#/vendors"><span>{$_('nav_user_vendors')}</span></a></li>
     {/if}
     {#if $userStore.getAcl('manageRate')}
     <li><a href="#/rates" on:keydown={() => {}} on:click={status.toggle('user')} ><span>{$_('nav_user_rates')}</span></a></li>
     {/if}
     <li class="divider"></li>
    <li class="title"><img src="/icons/scent-sim3d.svg" alt="scent" id="scent-icon"/>{$_('nav_user_scenes')}</li>
    <li><a href="/sim3d.html" on:keydown={() => {}} on:click={status.toggle('user')}><span>{$_('nav_user_newComposition')}</span></a></li>
      {#if $userStore.getAcl("dbOrders")}
        <li><a href="#/orderEdit" on:keydown={() => {}} on:click={status.toggle('user')}><span>{$_("home_createComposition2D")}</span></a></li>
      {/if}
     
     <li class="divider two"></li>
     <li class="title lang" on:keydown={() => {}} on:click={() => langOption = !langOption }><img src="/icons/language-sim3d.svg" alt="scent"  id="language-icon"/>{$_('nav_user_language')}</li>
     {#if langOption}
     <div transition:slide>
        {#each langs as lang}
        <li class:active-lang={$locale === lang.code} on:keydown={() => {}} on:click={() => $locale === lang.code ? null : lang.action()} id="li-language-pc"><span>{lang.name}</span></li>
        {/each}
      </div>
     {/if}
     <li class="divider three"></li>
     <li class="title logout" on:keydown={() => {}} on:click={logoutButton}><img src="/icons/logout.svg" class="filter-blue4" alt="logout"  id="close-icon"/>{$_('nav_user_logout')}</li>
  </ul>
  <div class="legal">
    <a href="/#/about">{$_('nav_legal_about')}</a> |
    <a href="/#/data-protection">{$_('nav_legal_dataProtection')}</a>
  </div>
  {:else if status.cart}
  <div in:fly={{ x: 500, duration: 300 }} out:fly={{ x: 500, duration: 100 }} class="cart-container">
    <ShoppingCart />
  </div>
  {/if}
  <ul class="icons-down">
    {#if langOption}
    <div transition:slide class="language-box">
       {#each langs as lang}
       <li class:active-lang={$locale === lang.code} on:keydown={() => {}} on:click={() => $locale === lang.code ? null : lang.action()}><span>{lang.name}</span></li>
       {/each}
     </div>
    {/if}
    <li class="title lang-mobile" on:keydown={() => {}} on:click={() => langOption = !langOption }><img src="/icons/language-sim3d.svg" class="filter-blue4" alt="scent"  id="language-icon"/></li>
    <li class="title logout-mobile" on:keydown={() => {}} on:click={logoutButton}><img src="/icons/logout.svg" class="filter-blue4" alt="logout"  id="close-icon"/></li>
  </ul>
</div>
{/if}
{#if tutoOpen}
<div class="tuto-container" style={'z-index: '+(index+1)} on:keydown={() => {}} on:click|stopPropagation>
  <div class="close" on:keydown={() => {}} on:click={() => tutoOpen = false }>
    <img src="/templates/sim3d/images/close-sim3d-azul4.svg" id="close-tutorial" alt="close"/>
  </div>
  <iframe src={"/#/tuto?"+tutoPath} title="Tutorial sim3D" frameborder="0" height="100%" width="100%"></iframe>
  <!-- <Tutorial bind:tutoPath/> -->
</div>
{/if}
<Loading bind:index bind:active={tutoOpen}/>

<svelte:head>
  <style>
    html::-webkit-scrollbar, body::-webkit-scrollbar, main::-webkit-scrollbar {
      display: none;
    }
  </style>
</svelte:head>

<style>
  a {
    text-decoration: none;
  }

  .cart-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

.icons-nav img {
  width: 30px;
  cursor: pointer;
}

/** close iframe button **/
.close {
  width: 45px;
  position: absolute;
  right: 15px;
  top: 15px;
  padding: 2.5px;
  z-index: 500;
  cursor: pointer;
}

.tuto-container {
  z-index: 151;
  position: absolute;
  height: 90vh;
  width: 90vw;
  background-color: white;
  margin: 5vh 5vw;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

.active-lang {
  font-weight: bold;
}

body {
  background-color: transparent;
}

div.s3d-badge {
  background-color: red;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  font-size: 13px;
  padding-top: 0;
  text-align: center;
  position: absolute;
  right: 2px;
  margin-top: -12px;
}

.arrow-item.shopping-cart-button {
  overflow: visible;
}

nav > div {
  background-color: var(--theme-color-4);
  position: fixed;
  height: 100vh;
  width: 3rem;
  z-index: 100;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
}

nav {
  width: 3rem;
  float: right;
  height: 100vh;
}

nav header, nav body, nav footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
}

nav header {
  justify-content: start;
  gap: 10px;
}

nav body {
  justify-content: center;
}

nav footer {
  justify-content: end;
}

.user-visible {
  right: 3rem !important;
}
.user {
  padding-top: 8rem;
  height: 100vh;
  width: 18vw;
  background-color: white;
  position: fixed;
  right: -16vw;
  z-index: 10;
  transition: right linear 0.3s;
  -webkit-box-shadow: -5px 0px 15px -12px rgba(0,0,0,0.5);
  box-shadow: -5px 0px 15px -12px rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
}

.user-actions {
  margin: 0 15%;
  line-height: 1.75rem;
  padding: 0;
}

.user-actions span {
  color: var(--theme-color-4);
  text-decoration: none;
}

.user-actions span:hover {
  color: var(--theme-color-1);
  cursor: pointer;
}

.user-actions a:hover {
  text-decoration: none;
}

#user-icon {
filter: var(--filter-blue4);

}

#scent-icon {
filter: var(--filter-blue4);

}
#language-icon {
filter: var(--filter-blue4);

}

#close-icon {
filter: var(--filter-blue4);

}

#list-icon {
   filter: var(--filter-blanco);
}

#list-icon {
filter: var(--filter-blanco);

}

  #close-list-icon {
    display: none;
  }

.arrow {
  height: 3rem;
  width: 1.5rem;
  background: var(--theme-color-4);
  position: absolute;
  top: 50vh;
  transform: translate(-100%, -50%);
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}

.arrow img {
  height: 40%;
}

li {
  margin-bottom: 5px;
  margin-left: 15px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

li img {
height: 30px;
margin-right: 10px;


}

.title {
  font-size: 20px;
  color: var(--theme-color-4);
  font-weight: 400;
  margin: 15px 0;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  letter-spacing: 1.5px;
}

.divider {
  border-bottom: dotted var(--theme-color-4) 2px;
  height: 12px;
  margin-left: 0;
}

.title.lang, .title.logout {
  cursor: pointer;
}

.icons-nav span {
  display: flex;
  justify-content: center;
  width: 100%;
  border-right: 0px solid white;
  border-left: 0px solid transparent;
  position: relative;
  height: 30px;
}

.icons-nav span.active-item {
  border-left-width: 2px;
  border-right-width: 2px;
}

.icons-nav span.active-item.arrow-item::before {
  border-width: 9px;
}

.icons-nav span.arrow-item::before {
  content: '';
  height: 0;
  position: absolute;
  left: -2px;
  top: 50%;
  transform: translateY(-50%);
  border: 0px solid transparent;
  border-left-color: white;
  transition: all ease-in .3s;
}


.icons-down {
   display: none;
}

#logo-sim3d-mobile {
  display: none;
}

@media (max-width: 1670px) {

  #close-tutorial {
   height: 30px;
  }

}

@media (min-width: 2269px) {

.tuto-container {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

}

.legal {
  position: absolute;
  bottom: 3px;
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 768px) and (min-width: 0px) { 

  nav {
    position: absolute;
    right: 0;
    background: white;
    height: 0px;
    margin: 20px 0;
  }

  .user {
    padding-top: 5rem;
    width: 100%;
    z-index: 101;
    position: fixed;
    right: 0 !important;
    background-color: var(--theme-color-4);
    overflow-y: scroll;
  }

  nav > div  {
    background-color: transparent;
    height: fit-content;    
    max-height: 0px;
  }

  nav header {
    margin:0;

  }
  nav body {
    display: none;
  }

  nav footer {
    display: none;
  }

  .icons-nav img {
    border-radius: 5px;
  }
  .divider {
    border-bottom: dotted var(--bs-white) 2px;
  }

  .arrow-item::before {
    display: none;
  }

  .title {
    color: var(--bs-white);
  }

  .user-actions span {
    color: var(--bs-white);
    text-decoration: none;
  }

  .icons-nav span.active-item {
    border-right-width: 0; 
  }


  #user-icon {
    filter: var(--filter-blanco);
  }

  #scent-icon {
    filter: var(--filter-blanco);
  }

  #language-icon {
    filter: var(--filter-blanco);
  }

  #close-icon {
   filter: var(--filter-blanco);
  }

  #list-icon {
   filter: var(--filter-blue4);
   cursor: pointer;
  }

  #logo-sim3d-mobile {
    display: block;
    position: absolute;
    top: 15px;
    left: 15px; 
  }
  #close-list-icon {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
    height: 25px;
  }

  #logo-sim3d-mobile img {
    height: 50px;
  }

  .lang {
    display: none;
  }

  .logout {
    display: none;
  }

  .three {
    display: none;
  }

  .two {
    display: none;
  }

  .icons-down {
    display: block;
    position: fixed;
    text-align: end;
    padding: 0 20px;
    width: 100%;
    bottom: 0;
  }

  #li-language-pc {
     display: none;
  }

  .language-box {
    background-color: var(--theme-color-4);
    width: 150px;
    border-radius: 5px;
    text-align: start;
    right: 0;
    padding: 10px;
    margin: 0 30px 0 auto;
    color: white;

  }

}

</style>